import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { switchMap } from 'rxjs';

import { AuthRequestOptions, NotificationService } from '@ntap/core';
import { AuthService } from '../../login.component/service/auth.service';
import { AppConfig, appConfigService } from '@app/config';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private notificationService: NotificationService,
    @Inject(appConfigService) private config: AppConfig
  ) {}

  public changePassword(request: {
    newPassword: string;
    repeatPassword: string;
    token: string;
  }): void {
    this.authService
      .getCsrfToken()
      .pipe(
        switchMap(() => {
          const url = this.config.apiHost + 'user/passwordChange';
          return this.http.post(url, request, new AuthRequestOptions());
        })
      )
      .subscribe({
        next: (response: any) => {
          const newCredentials = {
            username: response['username'],
            password: request.newPassword
          };
          this.authService.userChangedPassword(newCredentials);
          this.notificationService.success('Zaporka je izmijenjena.');
        },
        error: (error: any) => {
          this.notificationService.error(error.error.message || error.message);
        }
      });
  }
}
